import React from "react";

interface ConditionalFieldProps {
    size?: number | string;
    color?: string;
    className?: string;
    onClick?: () => void;
}

const ConditionalFieldIcon: React.FC<ConditionalFieldProps> = ({
    size = 20,
    color = '#003366',
    className,
    onClick,
}) => (
    <svg
        width={size}
        height={size}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        onClick={onClick}
    >
        <path d="M7.5 15.5C7.5 16.3284 8.17157 17 9 17C9.82843 17 10.5 16.3284 10.5 15.5C10.5 14.6716 9.82843 14 9 14C8.17157 14 7.5 14.6716 7.5 15.5Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.5 15.5C13.5 16.3284 14.1716 17 15 17C15.8284 17 16.5 16.3284 16.5 15.5C16.5 14.6716 15.8284 14 15 14C14.1716 14 13.5 14.6716 13.5 15.5Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M1.5 15.5C1.5 16.3284 2.17157 17 3 17C3.82843 17 4.5 16.3284 4.5 15.5C4.5 14.6716 3.82843 14 3 14C2.17157 14 1.5 14.6716 1.5 15.5Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M7.5 3.5C7.5 4.32843 8.17157 5 9 5C9.82843 5 10.5 4.32843 10.5 3.5C10.5 2.67157 9.82843 2 9 2C8.17157 2 7.5 2.67157 7.5 3.5Z" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M9 5L9 14" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M15 14V11C15 9.5 14.25 8.75 12.75 8.75L5.25 8.75C3.75 8.75 3 9.5 3 11V14" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />

    </svg>
);

export default ConditionalFieldIcon;